import { isTag, isElementNode } from 'anodum';
import isLastTextNodeOfElement from '../verifiers/is-last-text-node-of-element';
import splitTextByOffset from './split-text-by-offset';
import findFirstTextNode from './find-first-text-node';
import getCollapsedNodeAndOffset from './get-collapsed-node-and-offset';
import setCaretAtTheBeginningOfNode from './set-caret-at-the-beginning-of-node';
import findRootEditableElement from './find-root-editable-element';
import findNextNode from './find-next-node';
import { LINK_TAG, LIST_ITEM } from '../constants/editable-elements';

const insertBreakIntoEditableElement = () => {
  const [node, offset] = getCollapsedNodeAndOffset();
  const element = findRootEditableElement(node);

  if (!element) return;

  const { ownerDocument: liveDocument } = element;

  const breakElement = liveDocument.createElement('br');
  if (isElementNode(node) && isTag(node, 'br')) {
    node.insertAdjacentElement('beforebegin', breakElement);
    setCaretAtTheBeginningOfNode(breakElement.nextSibling);
    return;
  }

  const textNode = findFirstTextNode(node);

  // when selection is element node and text node isn't found should add 2 breaks
  if (isElementNode(node) && !textNode) {
    node.appendChild(breakElement);
    node.appendChild(breakElement.cloneNode(false));
    setCaretAtTheBeginningOfNode(breakElement.nextSibling);
    return;
  }

  const fragment = liveDocument.createDocumentFragment();
  const [leftText, rightText] = splitTextByOffset(textNode, offset);
  if (leftText) {
    const leftTextNode = liveDocument.createTextNode(leftText);
    fragment.appendChild(leftTextNode);
  }

  fragment.appendChild(breakElement);
  if (isLastTextNodeOfElement(textNode, node) && textNode.length === offset) {
    // when selection is in the end of editable element should add 2 breaks
    if (!(isElementNode(textNode.nextSibling) && isTag(textNode.nextSibling, 'br'))) {
      const nextNode = findNextNode(node, element);
      const isLinkInsideList =
        element && isTag(element, LIST_ITEM) && isTag(textNode.parentNode, LINK_TAG);

      if (!nextNode && isLinkInsideList && !rightText) {
        textNode.parentNode.after(breakElement);
        textNode.parentNode.after(breakElement.cloneNode(false));
        setCaretAtTheBeginningOfNode(breakElement);
        return;
      }

      fragment.appendChild(breakElement.cloneNode(false));

      if (nextNode && isElementNode(nextNode) && isTag(nextNode, 'br')) {
        nextNode.remove();
      }
    }
  }

  let rightTextNode;
  if (rightText) {
    rightTextNode = liveDocument.createTextNode(rightText);
    fragment.appendChild(rightTextNode);
  }

  textNode.parentNode.replaceChild(fragment, textNode);

  setCaretAtTheBeginningOfNode(rightTextNode || breakElement.nextSibling);
};

export default insertBreakIntoEditableElement;
